import { render, staticRenderFns } from "./ModalExternalContent.vue?vue&type=template&id=2b112b81&scoped=true&"
import script from "./ModalExternalContent.vue?vue&type=script&lang=js&"
export * from "./ModalExternalContent.vue?vue&type=script&lang=js&"
import style0 from "./ModalExternalContent.vue?vue&type=style&index=0&id=2b112b81&prod&lang=scss&scoped=true&"
import style1 from "./ModalExternalContent.vue?vue&type=style&index=1&id=2b112b81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b112b81",
  null
  
)

export default component.exports